import React from 'react';
import TOCompleteLoginView from "../Views/TO/Code/CompleteLoginView"
import MfaEmailPage from '../Login/MfaEmailPage';
import MfaTrustPage from '../Login/MfaTrustPage';

class CompleteLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            username: null,
            payload: null,
            showForm: this.props.signInType,
            step: "OTP",
            email: ""
        };
        this.displayForm = this.displayForm.bind(this);
        this.savePayload = this.savePayload.bind(this);
        this.saveStep = this.saveStep.bind(this);
        this.saveEmail = this.saveEmail.bind(this);
    }

    componentDidMount() {
        this.setState({ username: sessionStorage.AP_SSID });
        const payloadStr = sessionStorage.getItem("AP_PAYLOAD");
        if (payloadStr) {
            try {
                const payload = JSON.parse(payloadStr);
                sessionStorage.removeItem("AP_PAYLOAD");
                this.setState({ payload });
            } catch (error) {
                console.error("Invalid payload format", error);
                sessionStorage.removeItem("AP_PAYLOAD");
            }
        }
    }

    savePayload(value) {
        this.setState({ payload: value });
    }

    displayForm(value) {
        this.setState({ showForm: value });
    }

    saveStep(value) {
        this.setState({ step: value });
    }

    saveEmail(value) {
        this.setState({ email: value });
    }

    saveCode(value) {
    }


    render() {
        if (this.state.step === "EMAIL_CODE") {
            return (
                <MfaEmailPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} email={this.state.email} />
            )
        } else if (this.state.step === "TRUST") {
            return (
                <MfaTrustPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} />
            )
        } else {
            return (
                <TOCompleteLoginView
                    style={sessionStorage.AP_STYLE}
                    username={this.state.username}
                    payload={this.state.payload}
                    showForm={this.state.showForm}
                    signInType={this.props.signInType}
                    savePayload={this.savePayload}
                    saveCode={this.saveCode}
                    displayForm={this.displayForm}
                    saveStep={this.saveStep}
                    saveEmail={this.saveEmail}
                />
            )
        }
    }
}

export default CompleteLogin;